export default __webpack_public_path__ + "static/uk_flag-13af6021a7f282be3d10e0e5ee49bdd5.png";